import {mapActions} from 'vuex'

import template from './index.pug'
import ProfileRequestService from 'js/services/api/passenger/profile-requests.js'
import ProfileRequestViewFormModal from '../profile-request-view-form-modal'

const APPROVED_STATUS = 'approved'

export default Vue.extend({
  name: 'profile-requests-list',
  template: template(),
  components: {
    ProfileRequestViewFormModal
  },
  /**
   *  profileRequestId: objectID for get data
   *  typeForm: sets the form behavior to the modal (view, edit or create)
   */
  data() {
    return{
      accreditedProfiles: [],
      loadingProfile: false,
      profileRequests: [],
      showModal: false,
      profileRequestId: undefined,
      typeForm: 'view'
    }
  },
  created() {
    this.loadProfileRequest();
  },
  methods: {
    ...mapActions(['closeViewProfileAccreditationRequest']),

    loadProfileRequest() {
      const params = {
        administrative_area_id: this.$currentAccount.administrative_area_id,
        rut: this.$currentAccount.rut,
        document_type: this.$currentAccount.document_type || 1 //TODO: debería ser el del usuario
      }
      return ProfileRequestService.index(params).then(mp => {
        this.profileRequests = mp.data.filter(
          profileRequest => profileRequest.status !== APPROVED_STATUS
        )
      })
    },
    openModal(id, typeForm) {
      this.typeForm = typeForm
      this.profileRequestId = id
      this.showModal = true
    },
    closeModal() {
      this.showModal = false
    },
    formaterStatusRequest(status){
      return this.$t(`paymentMedias.status.${status}`)
    },
    uploadErrorDetails(accreditedProfile){
      return accreditedProfile?.objections?.reason
    }
  }
})
